import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortAlphabetically',
    standalone: false
})
export class SortAlphabeticallyPipe implements PipeTransform {
    transform(array: string[], asc = true) {
        const values = array?.sort((a, b) => a.localeCompare(b));
        return asc ? values : values?.reverse();
    }
}
